import { useMemo } from "react";
import { EnrolledBeneficiaryType } from "@/types/beneficiaries";

export const useBeneficiaryCalculations = (
  beneficiary: EnrolledBeneficiaryType,
) => {
  return useMemo(() => {
    const totalEmployerContrib =
      (beneficiary.employerMarketValue || 0) +
      (beneficiary.unvestedEmployerContribution || 0);

    const vestedAmount = beneficiary.employerMarketValue || 0;
    const vestingPercentage =
      totalEmployerContrib > 0
        ? ((vestedAmount / totalEmployerContrib) * 100).toFixed(2)
        : "0.00";

    const goalProgress = beneficiary.amountRequired
      ? (
          (beneficiary.marketValueAsOfDate / beneficiary.amountRequired) *
          100
        ).toFixed(2)
      : "0.00";

    return {
      totalEmployerContrib,
      vestedAmount,
      vestingPercentage,
      goalProgress,
      formatTruncatedMoney: (value: number) => Math.trunc(value),
    };
  }, [beneficiary]);
};
